import React from 'react';
import { createRoot } from 'react-dom/client';
import SearchDropdownMenu from './SearchDropdownMenu';
import CartContext from '../cart/cart-context';

export default (element, data) => {
  const init = () => {
    const root = createRoot(element);
    root.render(
      <CartContext data={data}>
        <SearchDropdownMenu {...data} />
      </CartContext>,
    );
  };

  init();
};
